import React from 'react';
import { PageSearchResultItem } from '../../../PageSearchResultItem/PageSearchResultItem';
import { ResultProps } from '../../resultProps';

export const CodaPageResult: React.FC<ResultProps> = ({ result }) => {
  return <PageSearchResultItem appName="Coda Page" result={result} />;
};
